export default () => {
  const aliases: { [key: string]: string } = {
    DEVELOPMENT: 'DEV',
  };
  const env = useRuntimeConfig().public.releaseEnvironment.toUpperCase();
  return aliases[env] || env;
};
